import React, { useState } from "react";
import Input from "../../../Input";
import toast from "react-hot-toast";
import { FormGrid } from "../../Users/AddANewUser";
import TextArea from "../../../TextArea";
import GoBack from '../../sub-components/GoBack'
import DocumentUpload from "../../sub-components/DocumentUploads";
import { StockService } from "../../../../services/StockService";
import moment from "moment";
import { useNavigate } from "react-router-dom";
const AddConcession = () => {
  let history = useNavigate();
  const [state, setState] = useState({
    concessionName: "",
    concessionSize: "",
    description: "",
    totalNumberOfTrees: "",
    address: "",
    permitNumber: "",
    permitExpiryDate: "",
    permitDocument: "",
    geoLocation: "",
    registrationDate: moment().format("YYYY-MM-DD")
  });

  const handleChange = (e) => {
    const { value, id } = e.target;
    setState((oldState) => ({ ...oldState, [id]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const toastId = toast.loading("Adding new Concession ");
    const file = state.permitDocument instanceof File ? state.permitDocument : null;
    StockService.AddConcession(
      state.concessionName,
      state.concessionSize,
      "",
      state.registrationDate,
      "0",
      state.address,
      state.geoLocation,
      state.permitNumber,
      state.permitExpiryDate,
      // The document is uploaded separately once the concession exists, so a storage
      // failure can't stop the concession itself from being saved.
      ""
    ).then(async (res) => {
      toast.dismiss(toastId);
      if (res.Successful) {
        if (file && res.data) {
          const uploadId = toast.loading("Uploading permit document...");
          const upload = await StockService.SaveConcessionDoc(file, res.data);
          toast.dismiss(uploadId);
          if (upload.Successful) {
            toast.success("Concession and permit document saved");
          } else {
            toast.error(
              `Concession saved, but the permit document couldn't be uploaded: ${upload.message}. Open the concession to try attaching it again.`,
              { duration: 8000 }
            );
          }
        } else {
          toast.success(res.message);
        }
        history("/dashboard/stock-management/concession");
      } else {
        toast.error(res.message);
      }
    });
  };
  return (
    <form className="flex flex-col w-full" onSubmit={handleSubmit}>
      <GoBack/>
      <h2 className="my-2 text-xl font-medium text-gray-700 ">
        New Concession 
      </h2>
       <FormGrid>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Concession Name
          </span>
          <Input
            id="concessionName"
            placeholder="Concession Name"
            type="text"
            value={state.concessionName}
            onChange={handleChange}
            required
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Concession Size
          </span>
          <Input
            id="concessionSize"
            placeholder="Concession Size"
            type="number"
            min="0"
            step="any"
            value={state.concessionSize}
            onChange={handleChange}
            required
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Address</span>
          <TextArea
            id="address"
            placeholder="Address"
            type="text"
            value={state.address}
            onChange={handleChange}
            required
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Geolocation</span>
          <Input
            id="geoLocation"
            placeholder="Geo Location"
            type="text"
            value={state.geoLocation}
            onChange={handleChange}
          />
        </label>
      </FormGrid>
      <h2 className="my-4 text-xl font-medium text-gray-700 ">Permit Info</h2>
      <FormGrid>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Permit Number
          </span>
          <Input
            id="permitNumber"
            placeholder="Permit Number"
            type="text"
            value={state.permitNumber}
            onChange={handleChange}
            required
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Permit Registration Date
          </span>
          <Input
            id="registrationDate"
            placeholder="Permit Expiry Date"
            type="date"
            value={state.registrationDate}
            onChange={handleChange}
            required
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Permit Expiry Date
          </span>
          <Input
            id="permitExpiryDate"
            placeholder="Permit Expiry Date"
            type="date"
            value={state.permitExpiryDate}
            onChange={handleChange}
            required
          />
        </label>
      </FormGrid>
      <span className="block mt-4 mb-3 text-gray-700 text-md">
        Permit Document
      </span>
      <DocumentUpload state={state} />
      <button
        type="submit"
        className="w-full sm:w-auto sm:px-3 bg-[#3e7c17] hover:bg-[#356C14] text-white font-semibold py-2 lg:py-3 my-3 rounded rounded-md self-end"
      >
        Create Concession
      </button>
    </form>
  );
};

export default AddConcession;
